export default __webpack_public_path__ + "static/media/JLEE_05_mos.83f14b75.wav";